import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { CollectionApi } from 'api';
import { ICollection, SearchCollectionsFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchCollectionsFilterType, size = 30) {
  return useAuthInfiniteList<ICollection>(
    [...getQueryKeys(KEY).lists(), 'infinite', { ...filter, size }],
    async (page) => {
      const res = await CollectionApi.getAll({ ...filter, page, size });
      return {
        data: { data: res.data.data, totalPages: res.data.totalPage },
      };
    },
  );
}

export default useGetInfinite;
